import {
  RESET_CONVERSATIONS,
  RESET_ERROR,
  RESET_USER_FILTER,
  GET_CONVERSATIONS,
  SET_CONVERSATIONS,
  GET_AGENTS,
  SET_AGENTS,
  GET_ACTIVITY,
  SET_ACTIVITY,
  GET_SKILLS,
  SET_SKILLS,
  GET_CONVERSATIONS_FORM,
  SET_CONVERSATIONS_FORM,
  SET_CONVERSATIONS_FILTER,
  API_ERROR,
  SET_GENERAL_FILTER,
  GET_USER_FILTER,
  SET_USER_FILTER,
  UPDATE_USER_FILTER,
  UPDATE_USER_FILTER_SUCCESS,
  RESET_MANAGER_PANEL,
  GET_TABS_BY_SKILL,
  GET_TABS_BY_SKILL_LOADING,
  GET_TABS_BY_SKILL_ERROR,
  GET_TABS_BY_SKILL_SUCCESS,
  HANDLE_LOGOUT_AGENT,
  HANDLE_LOGOUT_AGENT_SUCCESS,
  HANDLE_LOGOUT_AGENT_ERROR,
  HANDLE_LOGOUT_AGENT_CONFIRM,
  HANDLE_TRANSFER_CHATS_SUCCESS,
} from "./actionTypes";

export const resetConversations = () => {
  return {
    type: RESET_CONVERSATIONS,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const resetUserFilter = () => {
  return {
    type: RESET_USER_FILTER,
    payload: {},
  };
};

export const getConversations = (page, qtd, filters, order, sort) => {
  return {
    type: GET_CONVERSATIONS,
    payload: { page, qtd, filters, order, sort },
  };
};

export const setConversations = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_CONVERSATIONS,
    payload: { ...data, paging },
  };
};

export const getAgents = (page, qtd, filters) => {
  return {
    type: GET_AGENTS,
    payload: { page, qtd, filters },
  };
};

export const setAgents = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_AGENTS,
    payload: { ...data, paging },
  };
};

export const getActivity = (filters) => {
  return {
    type: GET_ACTIVITY,
    payload: { filters },
  };
};

export const setActivity = (data) => {
  return {
    type: SET_ACTIVITY,
    payload: { data },
  };
};

export const getSkills = (filters) => {
  return {
    type: GET_SKILLS,
    payload: { filters },
  };
};

export const setSkills = (data) => {
  return {
    type: SET_SKILLS,
    payload: { data },
  };
};

export const getTabsBySkill = (skillId) => {
  return {
    type: GET_TABS_BY_SKILL,
    payload: { skillId },
  };
};

export const getTabsBySkillLoading = () => {
  return {
    type: GET_TABS_BY_SKILL_LOADING,
  };
};

export const getTabsBySkillSuccess = (data) => {
  return {
    type: GET_TABS_BY_SKILL_SUCCESS,
    payload: { ...data },
  };
};

export const getTabsBySkillError = () => {
  return {
    type: GET_TABS_BY_SKILL_ERROR,
  };
};

export const getConversationsForm = () => {
  return {
    type: GET_CONVERSATIONS_FORM,
    payload: {},
  };
};

export const setConversationsForm = (data) => {
  return {
    type: SET_CONVERSATIONS_FORM,
    payload: { ...data },
  };
};

export const setConversationsFilter = (target, data) => {
  return {
    type: SET_CONVERSATIONS_FILTER,
    payload: { target, data },
  };
};

export const setGeneralFilter = (data) => {
  return {
    type: SET_GENERAL_FILTER,
    payload: { data },
  };
};

export const getUserFilter = (idUser) => {
  return {
    type: GET_USER_FILTER,
    payload: { idUser },
  };
};

export const setUserFilter = (data) => {
  return {
    type: SET_USER_FILTER,
    payload: { data },
  };
};

export const updateUserFilter = (idUser, templateFilter) => {
  return {
    type: UPDATE_USER_FILTER,
    payload: { idUser, templateFilter },
  };
};

export const updateUserFilterSuccess = (message) => {
  return {
    type: UPDATE_USER_FILTER_SUCCESS,
    payload: { message },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const setInitialStateManagerPanel = () => {
  return {
    type: RESET_MANAGER_PANEL,
    payload: {},
  };
};

export const handleLogoutAgent = (idAgent) => {
  return {
    type: HANDLE_LOGOUT_AGENT,
    payload: { idAgent },
  };
};

export const handleLogoutAgentSuccess = (idAgent) => {
  return {
    type: HANDLE_LOGOUT_AGENT_SUCCESS,
    payload: { idAgent },
  };
};

export const handleLogoutAgentError = (idAgent, error) => {
  return {
    type: HANDLE_LOGOUT_AGENT_ERROR,
    payload: {
      idAgent,
      error,
    },
  };
};

export const handleLogoutAgentConfirm = (idAgent, data) => {
  return {
    type: HANDLE_LOGOUT_AGENT_CONFIRM,
    payload: {
      idAgent,
      data,
    },
  };
};
